import http from '@/http/aisea/axios'
const resource = "/enterprise/vessel";

export default {
  search(params) {
    return http.get(`${resource}s/search`, {
      params: params
    });
  },

  fetchVessel(vesselId) {
    return http.get(`${resource}/${vesselId}`);
  },

  fetchCameras(vesselId) {
    return http.get(`${resource}s/${vesselId}/cameras`);
  },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  save(payload) {
    return http.put(`${resource}`, payload);
  },

  enable(vesselId) {
    return http.post(`${resource}/${vesselId}/enable`);
  },

  disable(vesselId) {
    return http.delete(`${resource}/${vesselId}/enable`);
  },

  index() {
    return http.get(`${resource}s/index`);
  },

  updateSortOrder(payload) {
    return http.put(`${resource}s/sort_order`, payload);
  }
};
